/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ComprobarInteraccionFarmacoDto } from '../models/comprobar-interaccion-farmaco-dto';
import { EfectoSecundarioModelDto } from '../models/efecto-secundario-model-dto';
import { EfectoSecundarioPacienteDto } from '../models/efecto-secundario-paciente-dto';
import { FarmacoDto } from '../models/farmaco-dto';
import { FarmacoPacienteDto } from '../models/farmaco-paciente-dto';
import { farmacosControllerActualizarFarmacoPaciente } from '../fn/paciente-farmacos/farmacos-controller-actualizar-farmaco-paciente';
import { FarmacosControllerActualizarFarmacoPaciente$Params } from '../fn/paciente-farmacos/farmacos-controller-actualizar-farmaco-paciente';
import { farmacosControllerActualizarFarmacoPacienteFarmaciaHospitalaria } from '../fn/paciente-farmacos/farmacos-controller-actualizar-farmaco-paciente-farmacia-hospitalaria';
import { FarmacosControllerActualizarFarmacoPacienteFarmaciaHospitalaria$Params } from '../fn/paciente-farmacos/farmacos-controller-actualizar-farmaco-paciente-farmacia-hospitalaria';
import { farmacosControllerBuscarFarmacos } from '../fn/paciente-farmacos/farmacos-controller-buscar-farmacos';
import { FarmacosControllerBuscarFarmacos$Params } from '../fn/paciente-farmacos/farmacos-controller-buscar-farmacos';
import { farmacosControllerComprobarInteraccionFarmacoPaciente } from '../fn/paciente-farmacos/farmacos-controller-comprobar-interaccion-farmaco-paciente';
import { FarmacosControllerComprobarInteraccionFarmacoPaciente$Params } from '../fn/paciente-farmacos/farmacos-controller-comprobar-interaccion-farmaco-paciente';
import { farmacosControllerEliminarFarmacoPaciente } from '../fn/paciente-farmacos/farmacos-controller-eliminar-farmaco-paciente';
import { FarmacosControllerEliminarFarmacoPaciente$Params } from '../fn/paciente-farmacos/farmacos-controller-eliminar-farmaco-paciente';
import { farmacosControllerGetDetalleFarmacoPaciente } from '../fn/paciente-farmacos/farmacos-controller-get-detalle-farmaco-paciente';
import { FarmacosControllerGetDetalleFarmacoPaciente$Params } from '../fn/paciente-farmacos/farmacos-controller-get-detalle-farmaco-paciente';
import { farmacosControllerGetDetalleFarmacoPacienteFarmaciaHospitalaria } from '../fn/paciente-farmacos/farmacos-controller-get-detalle-farmaco-paciente-farmacia-hospitalaria';
import { FarmacosControllerGetDetalleFarmacoPacienteFarmaciaHospitalaria$Params } from '../fn/paciente-farmacos/farmacos-controller-get-detalle-farmaco-paciente-farmacia-hospitalaria';
import { farmacosControllerGetEfectosSecundarios } from '../fn/paciente-farmacos/farmacos-controller-get-efectos-secundarios';
import { FarmacosControllerGetEfectosSecundarios$Params } from '../fn/paciente-farmacos/farmacos-controller-get-efectos-secundarios';
import { farmacosControllerGetEfectosSecundariosPacientePrograma } from '../fn/paciente-farmacos/farmacos-controller-get-efectos-secundarios-paciente-programa';
import { FarmacosControllerGetEfectosSecundariosPacientePrograma$Params } from '../fn/paciente-farmacos/farmacos-controller-get-efectos-secundarios-paciente-programa';
import { farmacosControllerGetFarmacosPaciente } from '../fn/paciente-farmacos/farmacos-controller-get-farmacos-paciente';
import { FarmacosControllerGetFarmacosPaciente$Params } from '../fn/paciente-farmacos/farmacos-controller-get-farmacos-paciente';
import { farmacosControllerGetTodosFarmacosEliminadosPaciente } from '../fn/paciente-farmacos/farmacos-controller-get-todos-farmacos-eliminados-paciente';
import { FarmacosControllerGetTodosFarmacosEliminadosPaciente$Params } from '../fn/paciente-farmacos/farmacos-controller-get-todos-farmacos-eliminados-paciente';
import { farmacosControllerGetTodosFarmacosPaciente } from '../fn/paciente-farmacos/farmacos-controller-get-todos-farmacos-paciente';
import { FarmacosControllerGetTodosFarmacosPaciente$Params } from '../fn/paciente-farmacos/farmacos-controller-get-todos-farmacos-paciente';
import { farmacosControllerGetTodosFarmacosPacienteFarmaciaHospitalaria } from '../fn/paciente-farmacos/farmacos-controller-get-todos-farmacos-paciente-farmacia-hospitalaria';
import { FarmacosControllerGetTodosFarmacosPacienteFarmaciaHospitalaria$Params } from '../fn/paciente-farmacos/farmacos-controller-get-todos-farmacos-paciente-farmacia-hospitalaria';
import { farmacosControllerInteraccionFarmacoPaciente } from '../fn/paciente-farmacos/farmacos-controller-interaccion-farmaco-paciente';
import { FarmacosControllerInteraccionFarmacoPaciente$Params } from '../fn/paciente-farmacos/farmacos-controller-interaccion-farmaco-paciente';
import { farmacosControllerRegistrarEfectoSecundarioPaciente } from '../fn/paciente-farmacos/farmacos-controller-registrar-efecto-secundario-paciente';
import { FarmacosControllerRegistrarEfectoSecundarioPaciente$Params } from '../fn/paciente-farmacos/farmacos-controller-registrar-efecto-secundario-paciente';
import { farmacosControllerRegistrarFarmacoPaciente } from '../fn/paciente-farmacos/farmacos-controller-registrar-farmaco-paciente';
import { FarmacosControllerRegistrarFarmacoPaciente$Params } from '../fn/paciente-farmacos/farmacos-controller-registrar-farmaco-paciente';
import { InteraccionFarmacoModelDto } from '../models/interaccion-farmaco-model-dto';
import { ListadoFarmacoPacienteDto } from '../models/listado-farmaco-paciente-dto';
import { RespuestaRegistrarFarmacoDto } from '../models/respuesta-registrar-farmaco-dto';

@Injectable({ providedIn: 'root' })
export class PacienteFarmacosService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `farmacosControllerBuscarFarmacos()` */
  static readonly FarmacosControllerBuscarFarmacosPath = '/api/farmacos/busqueda';

  /**
   * Obtiene una búsqueda de fármacos para un select con búsqueda en tiempo real.
   *
   * Devuelve una lista de fármacos que coinciden con el término de búsqueda para autocompletar/select.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `farmacosControllerBuscarFarmacos()` instead.
   *
   * This method doesn't expect any request body.
   */
  farmacosControllerBuscarFarmacos$Response(params: FarmacosControllerBuscarFarmacos$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FarmacoDto>>> {
    return farmacosControllerBuscarFarmacos(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtiene una búsqueda de fármacos para un select con búsqueda en tiempo real.
   *
   * Devuelve una lista de fármacos que coinciden con el término de búsqueda para autocompletar/select.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `farmacosControllerBuscarFarmacos$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  farmacosControllerBuscarFarmacos(params: FarmacosControllerBuscarFarmacos$Params, context?: HttpContext): Observable<Array<FarmacoDto>> {
    return this.farmacosControllerBuscarFarmacos$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FarmacoDto>>): Array<FarmacoDto> => r.body)
    );
  }

  /** Path part for operation `farmacosControllerGetFarmacosPaciente()` */
  static readonly FarmacosControllerGetFarmacosPacientePath = '/api/farmacos/farmacos-paciente/{programaUuid}';

  /**
   * Obtener fármacos del paciente autenticado para un programa.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `farmacosControllerGetFarmacosPaciente()` instead.
   *
   * This method doesn't expect any request body.
   */
  farmacosControllerGetFarmacosPaciente$Response(params: FarmacosControllerGetFarmacosPaciente$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FarmacoDto>>> {
    return farmacosControllerGetFarmacosPaciente(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener fármacos del paciente autenticado para un programa.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `farmacosControllerGetFarmacosPaciente$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  farmacosControllerGetFarmacosPaciente(params: FarmacosControllerGetFarmacosPaciente$Params, context?: HttpContext): Observable<Array<FarmacoDto>> {
    return this.farmacosControllerGetFarmacosPaciente$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FarmacoDto>>): Array<FarmacoDto> => r.body)
    );
  }

  /** Path part for operation `farmacosControllerInteraccionFarmacoPaciente()` */
  static readonly FarmacosControllerInteraccionFarmacoPacientePath = '/api/farmacos/farmacos-paciente-interacciones/{programaUuid}/{farmacoUuid}';

  /**
   * Revisa las interacciones posibles de un farmaco con un paciente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `farmacosControllerInteraccionFarmacoPaciente()` instead.
   *
   * This method doesn't expect any request body.
   */
  farmacosControllerInteraccionFarmacoPaciente$Response(params: FarmacosControllerInteraccionFarmacoPaciente$Params, context?: HttpContext): Observable<StrictHttpResponse<InteraccionFarmacoModelDto>> {
    return farmacosControllerInteraccionFarmacoPaciente(this.http, this.rootUrl, params, context);
  }

  /**
   * Revisa las interacciones posibles de un farmaco con un paciente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `farmacosControllerInteraccionFarmacoPaciente$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  farmacosControllerInteraccionFarmacoPaciente(params: FarmacosControllerInteraccionFarmacoPaciente$Params, context?: HttpContext): Observable<InteraccionFarmacoModelDto> {
    return this.farmacosControllerInteraccionFarmacoPaciente$Response(params, context).pipe(
      map((r: StrictHttpResponse<InteraccionFarmacoModelDto>): InteraccionFarmacoModelDto => r.body)
    );
  }

  /** Path part for operation `farmacosControllerActualizarFarmacoPaciente()` */
  static readonly FarmacosControllerActualizarFarmacoPacientePath = '/api/farmacos/farmacos-paciente/{programaUuid}/{farmacoUuid}';

  /**
   * Registrar un fármaco para el paciente autenticado en un programa.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `farmacosControllerActualizarFarmacoPaciente()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  farmacosControllerActualizarFarmacoPaciente$Response(params: FarmacosControllerActualizarFarmacoPaciente$Params, context?: HttpContext): Observable<StrictHttpResponse<FarmacoPacienteDto>> {
    return farmacosControllerActualizarFarmacoPaciente(this.http, this.rootUrl, params, context);
  }

  /**
   * Registrar un fármaco para el paciente autenticado en un programa.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `farmacosControllerActualizarFarmacoPaciente$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  farmacosControllerActualizarFarmacoPaciente(params: FarmacosControllerActualizarFarmacoPaciente$Params, context?: HttpContext): Observable<FarmacoPacienteDto> {
    return this.farmacosControllerActualizarFarmacoPaciente$Response(params, context).pipe(
      map((r: StrictHttpResponse<FarmacoPacienteDto>): FarmacoPacienteDto => r.body)
    );
  }

  /** Path part for operation `farmacosControllerRegistrarFarmacoPaciente()` */
  static readonly FarmacosControllerRegistrarFarmacoPacientePath = '/api/farmacos/farmacos-paciente/{programaUuid}/{farmacoUuid}';

  /**
   * Registrar un fármaco para el paciente autenticado en un programa.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `farmacosControllerRegistrarFarmacoPaciente()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  farmacosControllerRegistrarFarmacoPaciente$Response(params: FarmacosControllerRegistrarFarmacoPaciente$Params, context?: HttpContext): Observable<StrictHttpResponse<RespuestaRegistrarFarmacoDto>> {
    return farmacosControllerRegistrarFarmacoPaciente(this.http, this.rootUrl, params, context);
  }

  /**
   * Registrar un fármaco para el paciente autenticado en un programa.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `farmacosControllerRegistrarFarmacoPaciente$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  farmacosControllerRegistrarFarmacoPaciente(params: FarmacosControllerRegistrarFarmacoPaciente$Params, context?: HttpContext): Observable<RespuestaRegistrarFarmacoDto> {
    return this.farmacosControllerRegistrarFarmacoPaciente$Response(params, context).pipe(
      map((r: StrictHttpResponse<RespuestaRegistrarFarmacoDto>): RespuestaRegistrarFarmacoDto => r.body)
    );
  }

  /** Path part for operation `farmacosControllerActualizarFarmacoPacienteFarmaciaHospitalaria()` */
  static readonly FarmacosControllerActualizarFarmacoPacienteFarmaciaHospitalariaPath = '/api/farmacos/farmacos-paciente-farmacia-hospitalaria/{farmacoUuid}';

  /**
   * Actualizar un fármaco de farmacia hospitalaria para el paciente autenticado.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `farmacosControllerActualizarFarmacoPacienteFarmaciaHospitalaria()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  farmacosControllerActualizarFarmacoPacienteFarmaciaHospitalaria$Response(params: FarmacosControllerActualizarFarmacoPacienteFarmaciaHospitalaria$Params, context?: HttpContext): Observable<StrictHttpResponse<FarmacoPacienteDto>> {
    return farmacosControllerActualizarFarmacoPacienteFarmaciaHospitalaria(this.http, this.rootUrl, params, context);
  }

  /**
   * Actualizar un fármaco de farmacia hospitalaria para el paciente autenticado.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `farmacosControllerActualizarFarmacoPacienteFarmaciaHospitalaria$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  farmacosControllerActualizarFarmacoPacienteFarmaciaHospitalaria(params: FarmacosControllerActualizarFarmacoPacienteFarmaciaHospitalaria$Params, context?: HttpContext): Observable<FarmacoPacienteDto> {
    return this.farmacosControllerActualizarFarmacoPacienteFarmaciaHospitalaria$Response(params, context).pipe(
      map((r: StrictHttpResponse<FarmacoPacienteDto>): FarmacoPacienteDto => r.body)
    );
  }

  /** Path part for operation `farmacosControllerGetDetalleFarmacoPaciente()` */
  static readonly FarmacosControllerGetDetalleFarmacoPacientePath = '/api/farmacos/detalle/{programaUuid}/{farmacoUuid}';

  /**
   * Obtener el detalle de un fármaco de un paciente en un programa.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `farmacosControllerGetDetalleFarmacoPaciente()` instead.
   *
   * This method doesn't expect any request body.
   */
  farmacosControllerGetDetalleFarmacoPaciente$Response(params: FarmacosControllerGetDetalleFarmacoPaciente$Params, context?: HttpContext): Observable<StrictHttpResponse<FarmacoPacienteDto>> {
    return farmacosControllerGetDetalleFarmacoPaciente(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener el detalle de un fármaco de un paciente en un programa.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `farmacosControllerGetDetalleFarmacoPaciente$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  farmacosControllerGetDetalleFarmacoPaciente(params: FarmacosControllerGetDetalleFarmacoPaciente$Params, context?: HttpContext): Observable<FarmacoPacienteDto> {
    return this.farmacosControllerGetDetalleFarmacoPaciente$Response(params, context).pipe(
      map((r: StrictHttpResponse<FarmacoPacienteDto>): FarmacoPacienteDto => r.body)
    );
  }

  /** Path part for operation `farmacosControllerGetDetalleFarmacoPacienteFarmaciaHospitalaria()` */
  static readonly FarmacosControllerGetDetalleFarmacoPacienteFarmaciaHospitalariaPath = '/api/farmacos/detalle-farmaco-farmacia-hospitalaria/{farmacoUuid}';

  /**
   * Obtener el detalle de un fármaco de un paciente en un programa.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `farmacosControllerGetDetalleFarmacoPacienteFarmaciaHospitalaria()` instead.
   *
   * This method doesn't expect any request body.
   */
  farmacosControllerGetDetalleFarmacoPacienteFarmaciaHospitalaria$Response(params: FarmacosControllerGetDetalleFarmacoPacienteFarmaciaHospitalaria$Params, context?: HttpContext): Observable<StrictHttpResponse<FarmacoPacienteDto>> {
    return farmacosControllerGetDetalleFarmacoPacienteFarmaciaHospitalaria(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener el detalle de un fármaco de un paciente en un programa.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `farmacosControllerGetDetalleFarmacoPacienteFarmaciaHospitalaria$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  farmacosControllerGetDetalleFarmacoPacienteFarmaciaHospitalaria(params: FarmacosControllerGetDetalleFarmacoPacienteFarmaciaHospitalaria$Params, context?: HttpContext): Observable<FarmacoPacienteDto> {
    return this.farmacosControllerGetDetalleFarmacoPacienteFarmaciaHospitalaria$Response(params, context).pipe(
      map((r: StrictHttpResponse<FarmacoPacienteDto>): FarmacoPacienteDto => r.body)
    );
  }

  /** Path part for operation `farmacosControllerEliminarFarmacoPaciente()` */
  static readonly FarmacosControllerEliminarFarmacoPacientePath = '/api/farmacos/farmacos-paciente/{programaUuid}/{farmacoUuid}/eliminar';

  /**
   * Eliminar un fármaco de un usuario para un programa.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `farmacosControllerEliminarFarmacoPaciente()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  farmacosControllerEliminarFarmacoPaciente$Response(params: FarmacosControllerEliminarFarmacoPaciente$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return farmacosControllerEliminarFarmacoPaciente(this.http, this.rootUrl, params, context);
  }

  /**
   * Eliminar un fármaco de un usuario para un programa.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `farmacosControllerEliminarFarmacoPaciente$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  farmacosControllerEliminarFarmacoPaciente(params: FarmacosControllerEliminarFarmacoPaciente$Params, context?: HttpContext): Observable<void> {
    return this.farmacosControllerEliminarFarmacoPaciente$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `farmacosControllerGetTodosFarmacosEliminadosPaciente()` */
  static readonly FarmacosControllerGetTodosFarmacosEliminadosPacientePath = '/api/farmacos/farmacos-eliminados-paciente/{programaUuid}';

  /**
   * Obtener todos los fármacos eliminados del paciente autenticado.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `farmacosControllerGetTodosFarmacosEliminadosPaciente()` instead.
   *
   * This method doesn't expect any request body.
   */
  farmacosControllerGetTodosFarmacosEliminadosPaciente$Response(params: FarmacosControllerGetTodosFarmacosEliminadosPaciente$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FarmacoDto>>> {
    return farmacosControllerGetTodosFarmacosEliminadosPaciente(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener todos los fármacos eliminados del paciente autenticado.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `farmacosControllerGetTodosFarmacosEliminadosPaciente$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  farmacosControllerGetTodosFarmacosEliminadosPaciente(params: FarmacosControllerGetTodosFarmacosEliminadosPaciente$Params, context?: HttpContext): Observable<Array<FarmacoDto>> {
    return this.farmacosControllerGetTodosFarmacosEliminadosPaciente$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FarmacoDto>>): Array<FarmacoDto> => r.body)
    );
  }

  /** Path part for operation `farmacosControllerGetTodosFarmacosPaciente()` */
  static readonly FarmacosControllerGetTodosFarmacosPacientePath = '/api/farmacos/farmacos-paciente';

  /**
   * Obtener todos los fármacos del paciente autenticado.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `farmacosControllerGetTodosFarmacosPaciente()` instead.
   *
   * This method doesn't expect any request body.
   */
  farmacosControllerGetTodosFarmacosPaciente$Response(params?: FarmacosControllerGetTodosFarmacosPaciente$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ListadoFarmacoPacienteDto>>> {
    return farmacosControllerGetTodosFarmacosPaciente(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener todos los fármacos del paciente autenticado.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `farmacosControllerGetTodosFarmacosPaciente$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  farmacosControllerGetTodosFarmacosPaciente(params?: FarmacosControllerGetTodosFarmacosPaciente$Params, context?: HttpContext): Observable<Array<ListadoFarmacoPacienteDto>> {
    return this.farmacosControllerGetTodosFarmacosPaciente$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ListadoFarmacoPacienteDto>>): Array<ListadoFarmacoPacienteDto> => r.body)
    );
  }

  /** Path part for operation `farmacosControllerGetTodosFarmacosPacienteFarmaciaHospitalaria()` */
  static readonly FarmacosControllerGetTodosFarmacosPacienteFarmaciaHospitalariaPath = '/api/farmacos/farmacos-paciente-farmacia-hospitalaria';

  /**
   * Obtener todos los fármacos del paciente autenticado.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `farmacosControllerGetTodosFarmacosPacienteFarmaciaHospitalaria()` instead.
   *
   * This method doesn't expect any request body.
   */
  farmacosControllerGetTodosFarmacosPacienteFarmaciaHospitalaria$Response(params?: FarmacosControllerGetTodosFarmacosPacienteFarmaciaHospitalaria$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ListadoFarmacoPacienteDto>>> {
    return farmacosControllerGetTodosFarmacosPacienteFarmaciaHospitalaria(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener todos los fármacos del paciente autenticado.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `farmacosControllerGetTodosFarmacosPacienteFarmaciaHospitalaria$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  farmacosControllerGetTodosFarmacosPacienteFarmaciaHospitalaria(params?: FarmacosControllerGetTodosFarmacosPacienteFarmaciaHospitalaria$Params, context?: HttpContext): Observable<Array<ListadoFarmacoPacienteDto>> {
    return this.farmacosControllerGetTodosFarmacosPacienteFarmaciaHospitalaria$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ListadoFarmacoPacienteDto>>): Array<ListadoFarmacoPacienteDto> => r.body)
    );
  }

  /** Path part for operation `farmacosControllerRegistrarEfectoSecundarioPaciente()` */
  static readonly FarmacosControllerRegistrarEfectoSecundarioPacientePath = '/api/farmacos/efecto-secundario/{programaUuid}/{efectoSecundarioUuid}';

  /**
   * Registrar un efecto secundario para el paciente en un programa.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `farmacosControllerRegistrarEfectoSecundarioPaciente()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  farmacosControllerRegistrarEfectoSecundarioPaciente$Response(params: FarmacosControllerRegistrarEfectoSecundarioPaciente$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return farmacosControllerRegistrarEfectoSecundarioPaciente(this.http, this.rootUrl, params, context);
  }

  /**
   * Registrar un efecto secundario para el paciente en un programa.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `farmacosControllerRegistrarEfectoSecundarioPaciente$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  farmacosControllerRegistrarEfectoSecundarioPaciente(params: FarmacosControllerRegistrarEfectoSecundarioPaciente$Params, context?: HttpContext): Observable<void> {
    return this.farmacosControllerRegistrarEfectoSecundarioPaciente$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `farmacosControllerGetEfectosSecundarios()` */
  static readonly FarmacosControllerGetEfectosSecundariosPath = '/api/farmacos/efectos-secundarios';

  /**
   * Obtener efectos secundarios.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `farmacosControllerGetEfectosSecundarios()` instead.
   *
   * This method doesn't expect any request body.
   */
  farmacosControllerGetEfectosSecundarios$Response(params?: FarmacosControllerGetEfectosSecundarios$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EfectoSecundarioModelDto>>> {
    return farmacosControllerGetEfectosSecundarios(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener efectos secundarios.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `farmacosControllerGetEfectosSecundarios$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  farmacosControllerGetEfectosSecundarios(params?: FarmacosControllerGetEfectosSecundarios$Params, context?: HttpContext): Observable<Array<EfectoSecundarioModelDto>> {
    return this.farmacosControllerGetEfectosSecundarios$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<EfectoSecundarioModelDto>>): Array<EfectoSecundarioModelDto> => r.body)
    );
  }

  /** Path part for operation `farmacosControllerGetEfectosSecundariosPacientePrograma()` */
  static readonly FarmacosControllerGetEfectosSecundariosPacienteProgramaPath = '/api/farmacos/efectos-secundarios/{programaUuid}';

  /**
   * Obtener efectos secundarios del paciente autenticado para un programa.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `farmacosControllerGetEfectosSecundariosPacientePrograma()` instead.
   *
   * This method doesn't expect any request body.
   */
  farmacosControllerGetEfectosSecundariosPacientePrograma$Response(params: FarmacosControllerGetEfectosSecundariosPacientePrograma$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EfectoSecundarioPacienteDto>>> {
    return farmacosControllerGetEfectosSecundariosPacientePrograma(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener efectos secundarios del paciente autenticado para un programa.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `farmacosControllerGetEfectosSecundariosPacientePrograma$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  farmacosControllerGetEfectosSecundariosPacientePrograma(params: FarmacosControllerGetEfectosSecundariosPacientePrograma$Params, context?: HttpContext): Observable<Array<EfectoSecundarioPacienteDto>> {
    return this.farmacosControllerGetEfectosSecundariosPacientePrograma$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<EfectoSecundarioPacienteDto>>): Array<EfectoSecundarioPacienteDto> => r.body)
    );
  }

  /** Path part for operation `farmacosControllerComprobarInteraccionFarmacoPaciente()` */
  static readonly FarmacosControllerComprobarInteraccionFarmacoPacientePath = '/api/farmacos/comprobar-interaccion-farmaco/{programaUuid}/{farmacoUuid}';

  /**
   * Comprobar interacciones de un fármaco con los del paciente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `farmacosControllerComprobarInteraccionFarmacoPaciente()` instead.
   *
   * This method doesn't expect any request body.
   */
  farmacosControllerComprobarInteraccionFarmacoPaciente$Response(params: FarmacosControllerComprobarInteraccionFarmacoPaciente$Params, context?: HttpContext): Observable<StrictHttpResponse<ComprobarInteraccionFarmacoDto>> {
    return farmacosControllerComprobarInteraccionFarmacoPaciente(this.http, this.rootUrl, params, context);
  }

  /**
   * Comprobar interacciones de un fármaco con los del paciente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `farmacosControllerComprobarInteraccionFarmacoPaciente$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  farmacosControllerComprobarInteraccionFarmacoPaciente(params: FarmacosControllerComprobarInteraccionFarmacoPaciente$Params, context?: HttpContext): Observable<ComprobarInteraccionFarmacoDto> {
    return this.farmacosControllerComprobarInteraccionFarmacoPaciente$Response(params, context).pipe(
      map((r: StrictHttpResponse<ComprobarInteraccionFarmacoDto>): ComprobarInteraccionFarmacoDto => r.body)
    );
  }

}
